import React, { useState } from "react";
import {  Card } from "react-bootstrap";
import rightArrow from "../../assets/images/rightArrow.png";
import "./Projects.scss";
import groupImage from "../../assets/images/groupImage.png";
import lessthanIcon from "../../assets/images/lessThan.png";
import greaterthanIcon from "../../assets/images/greaterThan.png";
import ImageCard from "../../components/ImageCard/ImageCard";
import useWindowSize from "hooks/useWindowSize";
import ProgressBar from "react-bootstrap/ProgressBar";
import ShieldIcon from "assets/images/svg/ShieldIcon.svg";
import userImage from "assets/images/avatar.svg";
import classNames from "classnames";


import m1 from "assets/images/users/1.jpg";
import m2 from "assets/images/users/2.jpg";
import m3 from "assets/images/users/3.jpg";
import m4 from "assets/images/users/4.jpg";
import m5 from "assets/images/users/5.jpg";
import m6 from "assets/images/users/6.jpg";
import m7 from "assets/images/users/7.jpg";
import m8 from "assets/images/users/8.jpg";
import m9 from "assets/images/users/9.jpg";
import fm1 from "assets/images/users/01.jpg";
import fm2 from "assets/images/users/02.jpg";
import fm3 from "assets/images/users/03.jpg";
import fm5 from "assets/images/users/05.jpg";
import fm6 from "assets/images/users/06.jpg";
import fm7 from "assets/images/users/07.jpg";
import fm8 from "assets/images/users/08.jpg";
import fm9 from "assets/images/users/09.jpg";



export default function Projects() {
    const { isUltraWide } = useWindowSize(); 
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const users = [m1,fm2,m3,fm1,m5, fm6, m2, m3];
  const datas = [
    {
      title: "2023 Financial Review Audit",
      date: "Risk Audit",
      issues: 3,
      isOnTracking: true,
      progress: 70,
      users: [{}],
    },
    {
      title: "ICFR FY24 - US",
      date: "ICFR Audit",
      issues: 0,
      isOnTracking: true,
      progress: 70,
      users: [{}, {}, {}, {}],
    },
    {
      title: "Enhance Our Supply Chain ",
      date: "Strategic",
      issues: 0,
      isOnTracking: true,
      progress: 90,
      users: [{}, {}, {}],
    },
    {
      title: "Assessment Name 1",
      date: "Assessment",
      issues: 0,
      isOnTracking: true,
      progress: 60,
      users: [{}, {}, {}],
    },
    {
      title: "Assessment Name 2",
      date: "Strategic",
      issues: 2,
      isOnTracking: false,
      progress: 50,
      users: [{}, {}],
    },
    {
      title: "Assessment Name 5",
      date: "Workshop",
      issues: 0,
      isOnTracking: true,
      progress: 40,
      users: [{}, {}, {}],
    },
    {
      title: "Strategic Project 2",
      date: "Strategic",
      issues: 2,
      isOnTracking: false,
      progress: 40,
      users: [{}, {}, {}, {}, {}],
    },
    {
      title: "Strategic Project 5",
      date: "Workshop",
      issues: 0,
      isOnTracking: true,
      progress: 40,
      users: [{}],
    },
    {
      title: "Audit Name 1",
      date: "Risk Audit",
      issues: 2,
      isOnTracking: true,
      progress: 40,
      users: [{}, {}, {}],
    },
    {
      title: "Audit Name 2",
      date: "Risk Audit",
      issues: 0,
      isOnTracking: true,
      progress: 100,
      users: [{}, {}, {}, {}],
    },
  ];

  const searchDropdownData = [
    {
      name: "Risks",
      value: 307,
    },
    {
      name: "Controls",
      value: 127,
    },
    {
      name: "Processes",
      value: 468,
    },
    {
      name: "Regulations",
      value: 96,
    },
    {
      name: "Vendors",
      value: 163,
    },
  ];

  const fromGroupClass = classNames({
    "d-flex position-relative ease-in-2ms": true,
    "border-bottom-gray-600 pb-3 mb-3": isDropdownOpen,
  });

  const timeLineClass = classNames({
    "time-line slide-in": true,
    "slide-down": isDropdownOpen,
  });
  const imageCardData = {
    status:"High Risk",
    heading:"Supply chain disruptions",
    subHeading:"Supply chains will be disrupted based on ongoing geopolitical crisis, Covid, and inflationary pressures",
    relevance:"76",
    indicator1:"35",
    indicator2:"3",
    image:groupImage,
    relevancePercentage:"8",
    indicatorPercentage1:"8",
    indicatorPercentage2:"8"
  }
  return (
    <>
      {isUltraWide ? (
        <>
          <div className="pa-3">
            <form className="search-form">
              <div className={fromGroupClass}>
                <h3
                  className="fw-300 cp d-inline-flex align-items-center"
                  onClick={() => setDropdownOpen(!isDropdownOpen)}
                >
                  Projects
                  <i className="icon-chevron-down ml-1"></i>
                </h3>
                <input title="Search" type="text" />
                <i className="icon-search placeholder-icon"></i>
              </div>

              <ul className={timeLineClass}>
                {searchDropdownData.map((data, i) => (
                  <li className="" key={i}>
                    <h6 className="text-gray-50 fw-400">{data.name}</h6>
                    <small>
                      <span className="dot bg-indigo-600 mr-1"></span>{" "}
                      {data.value}
                    </small>
                  </li>
                ))}
              </ul>
            </form>

            {/* Timeline */}

            <ul className="time-line">
              {datas.map((data, i) => (
                <li className="d-flex justify-content-between" key={i}>
                  <div className="col-6 d-inline-flex align-items-center">
                    <span
                      className="circle text-white bg-gray-800"
                      style={{
                        width: "2.5rem",
                        height: "2.5rem",
                        overflow: "visible",
                      }}
                    >
                      <img
                        src={ShieldIcon}
                        style={{ width: "1.25rem" }}
                        alt="Strategy"
                      />
                    </span>

                    <div className="ml-3">
                      <h6 className="text-gray-50 fw-400">{data.title}</h6>
                      <span className="text-gray-400">
                        <i className="icon-map-pin mr-2"></i>
                        {data.date}
                        {data.issues > 0 && (
                          <>
                            <span className="mh-2">|</span>
                            <span className="text-danger">
                              {data.issues} overdue tasks
                            </span>
                          </>
                        )}
                      </span>
                    </div>
                  </div>

                  <div className="col-6  ">
                    <div className="d-flex">
                      <div className="col-5 d-flex justify-content-end mr-3">
                        {data.users.map((user: any, i: number) => (
                          <img
                            key={i}
                            className="circle mt-2 bg-gray-500"
                            style={{
                              width: "1.75rem",
                              height: "1.75rem",
                              marginLeft: "-0.5rem",
                            }}
                            src={users[i]}
                            alt="User"
                          />
                        ))}
                      </div>

                      <div className="fw">
                        <div className="d-flex align-items-center">
                          <ProgressBar variant="" now={data.progress} />
                          <span className="ml-3">{data.progress}%</span>
                        </div>

                        <small className="text-gray-500 fw-300 mt-2">
                          {data.isOnTracking ? "On track" : "Not started"}
                        </small>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </>
      ) : (
        <>
          <div className="Projects">
            <div className="">
              <h3>
                {" "}
                Project <img
                  className="rightArrowImg"
                  src={rightArrow}
                ></img>{" "}
              </h3>
              <div className="fw-300 text-2c text-gray-400">
                Where all risks, controls, processes, and regulations live
              </div>
            </div>

            <div className="row riskcard_container">
              <div className="col-md-7 col-lg-7 col-sm-12">
                <Card className="riskCard">
                  <label className="lable-header"> Tasks status </label>
                  <div className="row card-subheading">
                    <div className="col-md-3 col-lg-3 col-sm-6 vertical-line">
                      <div className="riskLevel">PLANNING</div>
                      <div className="percentage">
                        20{" "}
                        <div className="expLevel_Img">
                          <div className="icon-arrow-down"></div> 100%{" "}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-lg-3 col-sm-6 vertical-line ">
                      <div className="riskLevel">IN PROGRESS</div>
                      <div className="percentage">
                        10{" "}
                        <div className="expLevel_Img">
                          <div className="icon-arrow-down"></div> 100%{" "}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-lg-3 col-sm-6 vertical-line">
                      <div className="riskLevel">IN REVIEW</div>
                      <div className="percentage">
                        5{" "}
                        <div className="expLevel_Img">
                          <div className="icon-arrow-down"></div> 2{" "}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-lg-3 col-sm-6">
                      <div className="riskLevel">COMPLETED</div>
                      <div className="percentage">
                        <div>200</div>
                        <div className="expLevel_Img">
                          <div className="icon-arrow-down"></div> 2{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>

              <div className="col-md-5 col-lg-5 col-sm-12">
                <Card className="riskCard">
                  <div className="row">
                    <div className="col-md-10">
                      <label className="lable-header"> This Week </label>
                    </div>
                    <div className="col-md-2">
                      <img className="lessthanIcon" src={lessthanIcon} />
                      <img src={greaterthanIcon} />
                    </div>
                  </div>

                  <div className="row dateBorder">
                    <div className="col-md-9">
                      <div className="dateBox">
                        <div className="ellipse"></div>
                        <div className="illastrationDesc">
                          {" "}
                          Identify and analyze risks
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 date-style">
                      <div>Due date:</div>
                      <div>23 Apr 2023</div>
                    </div>
                  </div>
                </Card>
              </div>
            </div>

            <div>
              <div className="News-Header">
                <h3>
                  {" "}
                  News <img
                    className="rightArrowImg"
                    src={rightArrow}
                  ></img>{" "}
                </h3>
                <div className="fw-300 text-2c text-gray-400">
                  Global risk news&analysis articles.
                </div>
              </div>
            </div>

            <ImageCard imageCardData={imageCardData} />
            <ImageCard imageCardData={imageCardData} />
            <ImageCard imageCardData={imageCardData} />
          </div>
        </>
      )}
    </>
  );
}
